import React, { useContext, useEffect } from 'react'
import './ForgotUsernameJourney.scss'
import {
  ENVIRONMENT_VARIABLES,
  FORGEROCK_FORGOT_USERNAME_STAGES,
  FORGOT_USERNAME_JOURNEY,
  FORGOT_USERNAME_TITLE,
  FR_URL,
} from '~utils/constants'
import { checkPingTokenExpiry, initAuth } from '~utils/forgerock'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import CustomSkeletonLoader from '~components/CustomSkeletonLoader/CustomSkeletonLoader'
import SessionExpire from '~components/SessionExpire/SessionExpire'
import { StepType } from '@forgerock/javascript-sdk'
import UnknownError from '~components/UnknownError/UnknownError'
import CollectEmailForm from '~components/CollectEmailForm/CollectEmailForm'
import RetrieveUsernameSuccess from '~components/RetrieveUsernameSuccess/RetrieveUsernameSuccess'

const ForgotUsernameJourney = () => {
  const { step, nextStep, isLoading, frSessionTimeout, env, storeToken, setStoreToken, setStep } =
    useContext(UserContext) as IUserContextType
  const location = useLocation()
  const token = storeToken ? storeToken : location?.state?.storeToken

  useEffect(() => {
    const initializeJourney = async () => {
      if (token && env) {
        setStoreToken(token)
        initAuth(FORGOT_USERNAME_JOURNEY, token, ENVIRONMENT_VARIABLES[env][FR_URL])
        nextStep(undefined)
      } else {
        setStep(undefined)
      }
    }
    initializeJourney()
  }, [token, env])
  const stage = step?.payload?.stage

  return (
    <>
      {isLoading ? (
        <CustomSkeletonLoader />
      ) : (
        <>
          <Helmet>
            <title>{FORGOT_USERNAME_TITLE}</title>
          </Helmet>

          {(step === undefined ||
            (step?.type === StepType.Step &&
              !Object.values(FORGEROCK_FORGOT_USERNAME_STAGES).includes(stage))) &&
            !checkPingTokenExpiry() &&
            !frSessionTimeout && <UnknownError />}

          {step?.type === StepType.Step && (checkPingTokenExpiry() || frSessionTimeout) && (
            <SessionExpire token={token} />
          )}

          {step?.type === StepType.Step &&
            stage === FORGEROCK_FORGOT_USERNAME_STAGES.FORGOT_USERNAME_USERNAME &&
            !checkPingTokenExpiry() &&
            !frSessionTimeout && <CollectEmailForm key="CollectEmailForm" />}

          {step?.payload?.message && <div>{step?.payload?.message}</div>}
          {step?.type === StepType.LoginSuccess && <RetrieveUsernameSuccess />}
        </>
      )}
    </>
  )
}
export default ForgotUsernameJourney
/**
 * STATIC DATA AND UTILITIES
 */
